<template>
  <dx-scroll-view
    height="100%"
    width="100%"
    class="with-footer login-layout"
    :style="backgroundStyle"
  >
    <div class="dx-card">
      <slot />
    </div>
  </dx-scroll-view>
</template>

<script>
// import "../assets/styles/global.scss";
import DxScrollView from "devextreme-vue/scroll-view";

export default {
  components: {
    DxScrollView,
  },
  beforeMount() {
    let globalCss = document.querySelector("#global-css");
    globalCss.setAttribute("media", "");

    let salesCss = document.querySelector("#sales-css");
    salesCss.setAttribute("media", "");
  },
  computed: {
    backgroundStyle() {
      let baseUrl = process.env.VUE_APP_BASE_URL;

      if (baseUrl === "/")
        return `background-image: url(${baseUrl}statics/login.jpg);`;
      else return `background-image: url(/${baseUrl}/statics/login.jpg);`;
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.login-layout {
  .dx-card {
    width: 60vw;
    margin: auto auto;
    padding: 40px;
    background: #263238 !important;
    color: white;

    .screen-x-small & {
      width: 100%;
      height: 100%;
      border-radius: 0;
      box-shadow: none;
      margin: 0;
      border: 0;
      flex-grow: 1;
    }
  }
}
</style>
